import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-clinic-details',
  templateUrl: './clinic-details.component.html',
  styleUrls: ['./clinic-details.component.scss']
})
export class ClinicDetailsComponent implements OnInit {
  data: any;
  loading: boolean = true;

  constructor(
    public config: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    // Simulate loading time for better UX
    setTimeout(() => {
      this.data = this.config.data;
      console.log('Clinic Details:', this.data);
      this.loading = false;
    }, 500);
  }
}
